/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AnnouncementLogCreateInput = {
    announcementId: string;
};
export type AnnouncementDialogMutationVariables = {
    input: AnnouncementLogCreateInput;
};
export type AnnouncementDialogMutationResponse = {
    readonly announcementLogCreate: {
        readonly messages: ReadonlyArray<string>;
        readonly success: boolean;
    } | null;
};
export type AnnouncementDialogMutation = {
    readonly response: AnnouncementDialogMutationResponse;
    readonly variables: AnnouncementDialogMutationVariables;
};



/*
mutation AnnouncementDialogMutation(
  $input: AnnouncementLogCreateInput!
) {
  announcementLogCreate(input: $input) {
    messages
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AnnouncementLogPayload",
    "kind": "LinkedField",
    "name": "announcementLogCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "messages",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnnouncementDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnnouncementDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "215401ca525c85b945af89da57c4e9e2",
    "id": null,
    "metadata": {},
    "name": "AnnouncementDialogMutation",
    "operationKind": "mutation",
    "text": "mutation AnnouncementDialogMutation(\n  $input: AnnouncementLogCreateInput!\n) {\n  announcementLogCreate(input: $input) {\n    messages\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = '67481c5796a5f6f7d7be03e7c6c53251';
export default node;
